import styled from 'styled-components'
import { CheckBox } from 'ui/components/CheckBox'
import { Icon } from 'ui/components/Icon'

const PublicationWrapper = styled.li<{ needsReview: boolean }>`
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  padding: 20px 30px 12px 30px;
  margin-bottom: 28px;
  position: relative;
  border-radius: ${(p) => (p.needsReview ? '8px' : '0px')};
  list-style-type: none;
  background: ${(p) => (p.needsReview ? 'transparent' : '#f5f5f5')};

  svg {
    filter: drop-shadow(0px 4px 12px rgb(0 0 0 / 10%));
  }

  ${(p) =>
    p.needsReview
      ? `
  &:before {
    content: '';
    position: absolute;
    width: 13px;
    height: 74px;
    top: 50%;
    left: 13px;
    transform: translate(-100%, -50%);
    z-index: 1;
    background: #fff;
  }`
      : ''}
`

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
`

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`

const WrappedIcon = styled(Icon)`
  margin-right: 10px;
  height: 24px;
`

const DateTimeWrapper = styled.span`
  font-weight: 700;
  color: ${(p) => p.theme.uiKit.colors.global.grey.grey700};
  grid-column: 1 / 3;
`

const WrappedCheckBoxContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(-100%, -50%);
  height: 74px;
`

const WrappedCheckBox = styled(CheckBox)`
  position: absolute;
  z-index: 10;
  top: calc(50% - 8px);
  left: 14px;
`

const TitleLink = styled.h4`
  grid-column: 1 / 5;
  display: flex;
  align-items: center;
  color: ${(p) => p.theme.uiKit.colors.global.general.secondary};
  cursor: pointer;
`

const Title = styled.h4.attrs(() => ({ role: 'button' }))`
  grid-column: 1 / 5;
  color: ${(p) => p.theme.uiKit.colors.global.general.secondary};
  cursor: pointer;
`

const LongFilename = styled.span`
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 29px 32px;
`

export const s = {
  PublicationWrapper,
  Header,
  HeaderLeft,
  WrappedCheckBox,
  WrappedIcon,
  DateTimeWrapper,
  WrappedCheckBoxContainer,
  TitleLink,
  Title,
  LongFilename,
  AccordionWrapper
}
